import styled, { css } from 'styled-components'

export const Circle = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 2.4rem;
    height: 2.4rem;
    border-radius: ${theme.border.radius.circle};
    background-color: ${theme.colors.orange500};
    color: ${theme.colors.white};
  `,
)
